module.exports = __webpack_public_path__ + "img/clock-time-nine-outline.5866fd57.svg";